import {
  AssetBarStyle,
  AssetBarWrapper,
  AssetDataTextStyle,
  AssetDataWrapper,
  AssetIconImage,
  AssetsCompositionWrapper,
  CompositionTitleStyle,
  PortfolioCompositionWrapper,
} from './style'
import { AssetComposition, AssetCompositionView } from './interface'
import React from 'react'
import { getProductByAddress } from 'indices-list'
import { PortfolioPageProps } from 'pages/portfolio/interface'
import { ALL_PORTFOLIO_ID } from 'app-constants'
import { buildAssetComposition } from '../../../../utils/product-service'
import EmptyComposition from './Empty'
import { getAssetIconBySymbol } from 'abis/set/asset-icons'
const Composition: React.FC<PortfolioPageProps> = ({ portfolioStorage }) => {
  // grabs asset view data
  const { productBalances, errorProducts } = portfolioStorage
  const getAssetData = ({ id, value }: AssetComposition): AssetCompositionView => {
    const product = getProductByAddress(id)

    return {
      symbol: product.symbol.toUpperCase(),
      colorAccent:
        product.symbol === 'artxai' ? product.additionalBrandColour : product.brandColour,
      compositionPercentage: value.gt(0) ? value.toNumber() : 0,
    }
  }
  const assetComposition = buildAssetComposition(
    productBalances
      .filter((item) => item.id !== ALL_PORTFOLIO_ID)
      .filter((el) => !errorProducts.includes(el.id)),
  )

  return (
    <PortfolioCompositionWrapper id="tour-composition" className="portfolio-composition">
      <CompositionTitleStyle>Portfolio Composition</CompositionTitleStyle>
      <AssetsCompositionWrapper>
        {assetComposition.map((asset, index) => {
          const { colorAccent, compositionPercentage, symbol } = getAssetData(asset)
          return (
            compositionPercentage > 0 && (
              <AssetDataWrapper key={index}>
                <AssetIconImage src={getAssetIconBySymbol(symbol)} />
                <AssetDataTextStyle>{symbol}</AssetDataTextStyle>
                <AssetDataTextStyle>{compositionPercentage}%</AssetDataTextStyle>
                <AssetBarWrapper>
                  <AssetBarStyle width={compositionPercentage} color={colorAccent} />
                </AssetBarWrapper>
              </AssetDataWrapper>
            )
          )
        })}
      </AssetsCompositionWrapper>
    </PortfolioCompositionWrapper>
  )
}

const PortfolioComposition: React.FC<PortfolioPageProps> = ({ portfolioStorage }) => {
  if (portfolioStorage.isUserBalanceZero) {
    return <EmptyComposition />
  }
  return <Composition portfolioStorage={portfolioStorage} />
}

export default PortfolioComposition
